import React, { useEffect, useState } from "react"
import { Button, Divider, Drawer, Spin, Tooltip, Typography } from "antd"
import { db } from "../../../firebase/config"
import { doc, getDoc } from "firebase/firestore"
import { PlusCircleFilled } from "@ant-design/icons"
import CreateOrder from "../Orders/CreateOrder"

const { Text } = Typography

export default function NewOrderDrawer({ data }) {
  const [open, setOpen] = useState(false)
  const [currentManufacturer, setCurrentManufacturer] = useState({})
  const [currentClient, setCurrentClient] = useState({})
  const [drawerLoading, setDrawerLoading] = useState(true)

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  // When the drawer opens and we have data, fetch the client and then the manufacturer.
  useEffect(() => {
    setDrawerLoading(true)
    const fetchDocuments = async () => {
      try {
        if (open && data && data.clientId) {
          // 1. Fetch the client document.
          const clientRef = doc(db, "clients", data.clientId)
          const clientSnap = await getDoc(clientRef)
          if (clientSnap.exists()) {
            const currentData = { ...clientSnap.data(), id: clientSnap.id }
            setCurrentClient(currentData)

            // 2. Extract manufacturer id from the client data.
            const manufacturerId = currentData.manufacturer?.id || currentData.manufacturerId
            console.log("data", currentData)

            if (manufacturerId) {
              // 3. Fetch the manufacturer document from the "manufacturers" collection.
              const manufacturerRef = doc(db, "manufacturers", manufacturerId)
              const manufacturerSnap = await getDoc(manufacturerRef)
              if (manufacturerSnap.exists()) {
                const manufacturerData = { ...manufacturerSnap.data(), id: manufacturerSnap.id }
                setCurrentManufacturer(manufacturerData)
              } else {
                console.log("Manufacturer document not found!")
              }
            } else {
              console.log("No manufacturer id found in client data.")
            }
          } else {
            console.log("No client document found!")
          }
        }
      } catch (error) {
        console.error("Error getting document(s):", error)
      } finally {
        setDrawerLoading(false)
      }
    }

    fetchDocuments()
  }, [data, open])

  const returnCorrectLayout = () => {
    if (drawerLoading) {
      return <Spin />
    } else {
      return (
        <>
          <Divider>Fill Details</Divider>
          <CreateOrder
            fromDrawer={true}
            drawerProduct={data}
            drawerLoading={drawerLoading}
            drawerManufacturer={currentManufacturer}
            drawerClient={currentClient}
          />
        </>
      )
    }
  }

  // Disable order button logic
  const disableOrderButton = (data) => {
    if (data.machine === "Cutter") {
      return false
    } else {
      if (data.hasTechincalPage !== 2) {
        return true
      } else {
        return false
      }
    }
  }

  // Get active orders data
  const activeOrders = data?.currentlyInOrders || []
  const activeOrderCount = activeOrders.length

  // Create tooltip content with list of orders
  const tooltipContent =
    activeOrders.length > 0 ? (
      <div>
        <div style={{ marginBottom: 4, fontWeight: 600 }}>Active Orders:</div>
        {activeOrders.map((orderNumber, index) => (
          <div key={index}>{orderNumber}</div>
        ))}
      </div>
    ) : null

  return (
    <div>
      <Button
        disabled={disableOrderButton(data) || data.clientIsLead === true}
        size="small"
        onClick={showDrawer}
        icon={<PlusCircleFilled />}>
        <Text>Order</Text>
        {activeOrderCount > 0 && (
          <Tooltip title={tooltipContent} placement="top">
            <Text style={{ color: "#ff4d4f", marginLeft: 4 }}>({activeOrderCount})</Text>
          </Tooltip>
        )}
      </Button>
      <Drawer title="Create Order" placement="left" width={1000} onClose={onClose} open={open}>
        {returnCorrectLayout()}
      </Drawer>
    </div>
  )
}
